import { render, staticRenderFns } from "./scope48.vue?vue&type=template&id=23dacba9&scoped=true"
import script from "./scope48.vue?vue&type=script&lang=js"
export * from "./scope48.vue?vue&type=script&lang=js"
import style0 from "./scope48.vue?vue&type=style&index=0&id=23dacba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dacba9",
  null
  
)

export default component.exports